import { RTC_PROVIDERS } from '../../../providerIds'
import {
  AgoraRtcCompatibilitySurface,
  createAgoraRtcAdapterCapabilities,
  createAgoraRtcCompatibilityProps,
  preloadAgoraRtcUIKitModule,
} from './agoraRtcCompat'
import { createAgoraRtcPortBundle } from './createAgoraRtcPortBundle'
import { createAgoraRtcSessionHandle } from './createAgoraRtcSessionHandle'

export { AGORA_RTC_SESSION_EVENTS } from './createAgoraRtcSessionHandle'
export { createAgoraRtcSessionHandle } from './createAgoraRtcSessionHandle'

export function createAgoraRtcAdapter({ capabilityOverrides = {} } = {}) {
  return {
    id: RTC_PROVIDERS.agora,
    domain: 'rtc',
    compatibilityBridge: 'agora-uikit',
    supports: createAgoraRtcAdapterCapabilities(capabilityOverrides),
    preload: preloadAgoraRtcUIKitModule,
    CompatibilitySurface: AgoraRtcCompatibilitySurface,
    createCompatibilityProps: createAgoraRtcCompatibilityProps,
    createSession(initialConfig = {}) {
      return createAgoraRtcSessionHandle({
        initialConfig,
      })
    },
    createPortBundle(options = {}) {
      return createAgoraRtcPortBundle(options)
    },
  }
}

export const agoraRtcAdapter = createAgoraRtcAdapter()
